import { FC, JSX } from "react";

interface PaneProps {
    body: JSX.Element[];
    bodyRef?: React.RefObject<HTMLDivElement>;
    bulkActionBar: JSX.Element;
    title: string;
    totalSelected: string;
}

const ServiceAreaEditorPane: FC<PaneProps> = (props: PaneProps) => {
    return (
        <div className="service-area-editor__pane">
            <div className="service-area-editor__pane-title">{props.title}</div>
            <div className="service-area-editor__pane-bulk-action">{props.bulkActionBar}</div>
            <div className="service-area-editor__pane-body" ref={props.bodyRef}>{props.body}</div>
            <div className="service-area-editor__pane-total">Total Selected: {props.totalSelected}</div>
        </div>
    )
};

export { ServiceAreaEditorPane };
